import React, { useState } from 'react'
import AuthenticatedPage from 'containers/AuthenticatedPage'
import Tabs from 'components/Tabs'
import { getMessage } from 'lib/translator'
import MediaBulkUpload from './MediaBulkUpload'
import MediaBulkDelete from './MediaBulkDelete'
import MediaAuditLogs from './MediaAuditLogs'
import './style.scss'

const TAB_LABELS = [
  'catalogue.skuMediaUpload.tabs.bulkUpload',
  'catalogue.skuMediaUpload.tabs.bulkDelete',
  'catalogue.skuMediaUpload.tabs.auditLogs',
]

function SkuMediaUpload({ menu }) {
  const [activeTab, setActiveTab] = useState(0)

  return (
    <AuthenticatedPage className="sku-media-upload-page" menu={menu}>
      <h1>{getMessage('catalogue.skuMediaUpload.heading')}</h1>

      <div className="sku-media-tabs-header">
        <Tabs
          items={TAB_LABELS.map((key) => getMessage(key))}
          active={activeTab}
          onClick={setActiveTab}
        />
      </div>
      <div
        className={`sku-media-tab-contents${
          activeTab === 2 ? ' sku-media-tab-contents--audit-logs' : ''
        }`}
      >
        {activeTab === 0 && <MediaBulkUpload />}
        {activeTab === 1 && <MediaBulkDelete />}
        {activeTab === 2 && <MediaAuditLogs />}
      </div>
    </AuthenticatedPage>
  )
}

export default SkuMediaUpload
